<template>
    <v-dialog style="border-radius: 10px" v-model="dialog" persistent max-width="600px">
      <template class="caixinha-modal" v-slot:activator="{ on }">
        <v-btn class="caixinha-modal" flat dark v-on="on"><v-icon class="grey--text" small>chat_bubble</v-icon></v-btn>
      </template>
      <v-card style="border-radius: 10px">
        <v-card-text class="primary modal-title d-flex align-center">
          <span>Motivo do Cancelamento </span>
          <v-spacer></v-spacer>
          <v-btn class="sem-hover" color="white" style="height: auto; width: auto; text-align: end" flat @click="dialog = false"><v-icon medium>close</v-icon></v-btn>
        </v-card-text>
        <v-container class="pa-3 white mt-3">
          <v-card-text>
            {{ motivo }}
          </v-card-text>
        </v-container>
      </v-card>
    </v-dialog>
</template>

<script>

export default {
  name: 'CredenciamentoModalMotivoCancelamento',
  props: {
    motivo: null,
  },
  data () {
    return {
      dialog: false
    }
  }
}
</script>

<style>
.custom-header thead th {
  color: #0067a5 !important;
}

.caixinha-modal .v-btn{
  padding: 0 0 !important;
}

.caixinha-modal .v-btn__content{
  justify-content: start !important;
}

.sem-hover .v-btn__content{
  justify-content: end !important;
}

.v-btn::before{
  opacity: 0 !important;
}


</style>